import { Box, CardHeader, Text } from 'grommet'
import { ReactNode } from 'react'
import { Button } from '../Button'
import { SmallText } from '../Text'

export type TitleHeaderProps = {
  title: string
  additionalText?: string
  linktext?: ReactNode
} & ({ btnLabel?: undefined; onClick?: () => void } | { btnLabel: string; onClick: () => void }) &
  ({ secBtnLabel?: undefined; onSecBtnClick?: () => void } | { secBtnLabel: string; onSecBtnClick: () => void })

export const TitleHeader = ({
  btnLabel,
  onClick,
  title,
  additionalText,
  linktext,
  secBtnLabel,
  onSecBtnClick
}: TitleHeaderProps) => {
  return (
    <CardHeader align="start" direction="column" gap="12px" pad={{ bottom: '12px' }}>
      {linktext && linktext}
      <div className="flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <Box className="min-w-0">
          <Text className="capitalize text-[20px] md:text-[24px]" color="black" size="24px" weight={400}>
            {title}
          </Text>
          {additionalText && <SmallText>{additionalText}</SmallText>}
        </Box>
        {(btnLabel || secBtnLabel) && (
          <div className="flex flex-wrap items-center gap-2 md:gap-4">
            {secBtnLabel && onSecBtnClick ? (
              <Button kinds="secondary" label={secBtnLabel} onClick={onSecBtnClick} />
            ) : null}
            {btnLabel && onClick ? <Button kinds="primary" label={btnLabel} onClick={onClick} /> : null}
          </div>
        )}
      </div>
    </CardHeader>
  )
}
